import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Modal from 'antd/lib/modal';
import rules from '../../common/rules/rules';
import SmsResendControl from './SmsResendControl';

@translate()
@Form.create()
export default class ConfirmContractModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    hideModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    confirmBy: PropTypes.string.isRequired,
    onResendSmsCode: PropTypes.func,
    resendCooldownKey: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    // errorMessage: Redux-driven confirm error (e.g. invalid token) to show inline.
    errorMessage: PropTypes.string,
  };

  state = {
    inlineError: null,
    errorDismissed: false,
  };

  handleSubmit = () => {
    const { form, onSubmit } = this.props;

    form.validateFields((err, { token }) => {
      if (!err) {
        // Reset dismissal so that the new response's error (if any) is shown.
        this.setState({ errorDismissed: false });
        onSubmit(token);
      }
    });
  };

  handleTokenChange = () => {
    this.setState({ inlineError: null, errorDismissed: true });
  };

  renderForm() {
    const { form, t, onResendSmsCode, resendCooldownKey, errorMessage } = this.props;
    const { getFieldDecorator } = form;
    const { inlineError } = this.state;
    // Show the Redux-driven errorMessage unless the user has started typing
    // (errorDismissed flag), which clears it locally before Redux catches up.
    const { errorDismissed } = this.state;
    const displayError = inlineError || (!errorDismissed && errorMessage) || null;

    const resendHelp = (
      <SmsResendControl
        t={t}
        onResendSmsCode={onResendSmsCode}
        resendCooldownKey={resendCooldownKey}
      />
    );
    const help = displayError || resendHelp ? (
      <span>
        {displayError && (
          <span>{displayError}</span>
        )}
        {displayError && resendHelp && (
          <br />
        )}
        {resendHelp}
      </span>
    ) : undefined;

    return (
      <Form>
        <Form.Item
          help={help}
          validateStatus={displayError ? 'error' : undefined}
        >
          {getFieldDecorator('token', { rules: rules.required })(
            <Input
              size="default"
              placeholder={t('Kód SMS správy')}
              onChange={this.handleTokenChange}
            />
          )}
        </Form.Item>
      </Form>
    );
  }

  render() {
    const { isLoading, hideModal, t, confirmBy } = this.props;
    let title = t('Potvrdenie podpísania zmlúv');

    if (confirmBy === 'contractNumber') {
      title = t('Potvrdenie prijatia rámcovej zmluvy');
    }
    if (confirmBy === 'infoObligations') {
      title = t('Potvrdenie Informačných povinností klienta');
    }
    if (confirmBy === 'investorInfoObligations') {
      title = t('Potvrdenie Informačných povinností poskytovateľa služieb');
    }

    return (
      <Modal
        visible
        confirmLoading={isLoading}
        title={title}
        onOk={this.handleSubmit}
        onCancel={hideModal}
        okText={t('Odoslať')}
      >
        {this.renderForm()}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/modals/ConfirmContractModal.js